import { apiClient } from '@/core/apiClient';

export type EmailContact = {
  id: number;
  email: string;
  normalizedEmail: string;
  name?: string | null;
  linkedUserId?: number | null;
  status: 'active' | 'invalid' | 'suppressed';
  isEmailValid: boolean;
  isSuppressed: boolean;
  isUnsubscribed: boolean;
  createdSource: string;
  lastEmailSentAt?: string | null;
  createdAt: string;
};

export type EmailContactSource = {
  id: number;
  emailContactId: number;
  sourceType: string;
  sourceReference?: string | null;
  importId?: number | null;
  originalEmail?: string | null;
  originalName?: string | null;
  createdAt: string;
};

export type EmailContactListFilters = {
  search?: string;
  status?: string;
  isSuppressed?: boolean;
  isUnsubscribed?: boolean;
  source?: string;
  page?: number;
  pageSize?: number;
};

export type EmailContactSyncResult = {
  scannedUsers: number;
  created: number;
  linkedExisting: number;
  skippedInvalid: number;
};

export const emailContactsApi = {
  list: async (filters: EmailContactListFilters): Promise<{ items: EmailContact[]; total: number }> => {
    const res = await apiClient.get('/admin/email-contacts', { params: filters });
    return res.data;
  },

  findById: async (id: number): Promise<EmailContact & { sources: EmailContactSource[] }> => {
    const res = await apiClient.get(`/admin/email-contacts/${id}`);
    return res.data;
  },

  history: async (id: number) => {
    const res = await apiClient.get(`/admin/email-contacts/${id}/history`);
    return res.data;
  },

  update: async (id: number, payload: Partial<Pick<EmailContact, 'name' | 'isSuppressed' | 'isUnsubscribed' | 'isEmailValid'>>) => {
    const res = await apiClient.patch(`/admin/email-contacts/${id}`, payload);
    return res.data;
  },

  syncUsers: async (): Promise<EmailContactSyncResult> => {
    const res = await apiClient.post('/admin/email-contacts/sync-users');
    return res.data;
  },
};
